import { deleteDoc, doc } from "firebase/firestore";
import { RiDeleteBinLine } from "react-icons/ri"
import { db } from "../../firebaseFunctions/authhook";
type propType = {
  firstName: string,
  mobileNumber: string,
  id: string,
}

const Details: React.FC<propType | any> = ({ firstName, mobileNumber, date, indexNumber, id }) => {
  const today = new Date(date);
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = String(today.getMonth() + 1).padStart(2, '0'); 
  var yyyy = today.getFullYear();
  const handleSignleDelete = async (id:string) =>{
    await deleteDoc(doc(db, "appointment_lists", id));
  }
  return (
    <div className="group-2">
      <p className="txt-344">{mobileNumber}</p>
      <div className="group-389 flex-row">
        <div className="group-1061">
          <p className="txt-241">{indexNumber}</p>
        </div>
        <p className="txt-241">{firstName}</p>
      </div>
      <div>
        <small className="dateString">{dd}-{mm}-{yyyy}</small>
      </div>
      <div className="deleteIcon">
      <RiDeleteBinLine onClick={()=> handleSignleDelete(id)}/>
      </div>
    </div>
  )
}

export default Details;